import './offers.css';
import myFunction from './123456';
const Offerfiv =()=>{
    return(
        <div className="Offers">
            <div className="two">
  <img src="https://res.cloudinary.com/dggrpzdnl/image/upload/v1669023918/rsz_addchk99_q71szu.jpg" height="320px" width="320px"/>
  <div className="content">
    <h4><b>Junior chicken</b></h4> 
    <p>You don’t need to compromise with the great taste of a Junior Chicken sandwich</p>
    <p>Valid till November 28th</p> 
    <label class="AQWERST"></label>
    <input defaultValue="VEGGIETREAT2239" id="myInput" style={{opacity: 0}} />
    <center><button onClick={myFunction}>Copy coupon</button></center>
  </div>
</div>
        </div>
    )
};
export default Offerfiv;